import { useSelector } from 'react-redux';

import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { KnmReasonTypeNameEnum } from 'KnmPackage/MainModule/enums/KnmReasonTypeNameEnum';

import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import {
  getIsRsnCngPPXX,
  getIsRsnCngPPXXII,
  getKnmDataErknmApproveAppeal,
  getKnmDataErknmApproveApproved,
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { ApprovedTypesEnum } from '../../../APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { getIsPlanErknmStatusConsidered } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';

export const useIsApproveDocsEnabled = (formRef: IKnmFormRef | undefined) => {
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isKnmStatusFillInProcess = useSelector(getKnmIsErknmStatusFillInProcess);
  const isKnmStatusReadyForApprove = useSelector(getKnmIsErknmStatusReadyForApprove);
  const isEditableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const knmDataApproved = useSelector(getKnmDataErknmApproveApproved);
  const isKnmDataApproveAppeal = useSelector(getKnmDataErknmApproveAppeal);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const isRsnCngPPXXII = useSelector(getIsRsnCngPPXXII);
  const isRsnCngPPXX = useSelector(getIsRsnCngPPXX);
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.APPROVE_DOCS);

  const isActiveFieldPlanConsideredWithApprovedAppeal =
    knmDataApproved === ApprovedTypesEnum.APPROVED && !!isKnmDataApproveAppeal && isKnmPlanStatusConsidered;

  const reasonsErknm = formRef?.current.getFieldState('reasonsErknm')?.value;
  const isImpossibilityOfPrevious = reasonsErknm?.[0]?.type?.name === KnmReasonTypeNameEnum.IMPOSSIBILITY_OF_PREVIOUS;

  return (
    (!isCommonWatchOnly &&
      isSupervisor &&
      (isKnmStatusFillInProcess ||
        isKnmStatusReadyForApprove ||
        isActiveFieldPlanConsideredWithApprovedAppeal ||
        isEditableInStatusCommentsExist ||
        (isKnmStatusCommentsExist && isKnmPlanStatusConsidered && isRemarksExists)) &&
      !isImpossibilityOfPrevious) ||
    isRsnCngPPXXII ||
    isRsnCngPPXX
  );
};
